'use strict';

var waterfall = require('async/waterfall');

var _require = require('./utils'),
    traverseTo = _require.traverseTo,
    FILE_SEPARATOR = _require.FILE_SEPARATOR;

var defaultOptions = {};

module.exports = function (ipfs) {
  return function mfsFlush(path, options, callback) {
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }

    if (typeof path === 'function') {
      callback = path;
      options = {};
      path = FILE_SEPARATOR;
    }

    if (!path) {
      path = FILE_SEPARATOR;
    }

    options = Object.assign({}, defaultOptions, options);
    waterfall([function (cb) {
      return traverseTo(ipfs, path, {}, cb);
    }, function (root, cb) {
      cb();
    }], callback);
  };
};